import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { getBadgeColors, getBadgeOffset, getBadgeSize } from './getBadgeStyles';
import { BadgeVariant } from './types';

interface BadgeProps {
    children?: React.ReactChild;
    contentLength?: number;
    outline?: boolean;
    $content?: number | string;
    variant?: BadgeVariant;
}

export const BadgeElement = styled.span<BadgeProps>`
    ${getTextTokenPreset('bodyExtraSmallStrong')};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    ${({ variant }) => getBadgeColors(variant)};
    outline: ${({ outline, theme }) =>
        outline && `${getToken('borderWidth200')({ theme })}px solid ${getToken('borderStaticInverse')({ theme })}`};
    border-radius: ${({ outline }) => getToken(outline ? 'borderRadius200' : 'borderRadius100')}px;
    padding: ${(props) =>
        props.children && props.contentLength && props.contentLength > 1 ? `0 ${getSpacingToken('50')(props)}px` : '0'};
    ${getBadgeSize};
    flex-shrink: 0;
`;

export const BadgeWrapperContainerElement = styled.div`
    position: relative;
    display: flex;
`;

export interface NotificationContainerElementProps {
    $offset?: number;
}

export const BadgeContainerElement = styled.div<NotificationContainerElementProps>`
    position: absolute;
    z-index: 1;
    bottom: calc(100% - ${getBadgeOffset}px);
    left: calc(100% - ${getBadgeOffset}px);
    display: flex;
    justify-content: center;
    align-items: center;
`;
